import { render, staticRenderFns } from "./OES-tab.vue?vue&type=template&id=dac246ca&scoped=true"
import script from "./OES-tab.vue?vue&type=script&lang=js"
export * from "./OES-tab.vue?vue&type=script&lang=js"
import style0 from "./OES-tab.vue?vue&type=style&index=0&id=dac246ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac246ca",
  null
  
)

export default component.exports